"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXs, NotificationsSizeBorderWidth, NotificationsRadius, SpaceInsetSm } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
import { ICON_SIZE } from "./constants.js";
const StyledFlexBox = styled(Box)`
    display: flex;
    border: solid;
    gap: ${SpaceXs};
    border-width: ${NotificationsSizeBorderWidth};
    border-radius: ${NotificationsRadius};
    padding: ${SpaceInsetSm};
    background-color: ${(props) => props.color.backgroundColor};
    border-color: ${(props) => props.color.borderColor};
`;
const StyledIconBox = styled(Box)`
    display: flex;
    & > svg {
        width: ${ICON_SIZE};
        height: ${ICON_SIZE};
    }
`;
const StyledText = styled(Text)`
    flex: 1 1 auto;
`;
export {
  StyledFlexBox,
  StyledIconBox,
  StyledText
};
